<template>
	<div>
		<div class="bg-gray-12">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 p-y-sm filters-wrapper">
						<button class="btn btn-link btn-xs filters-btn" @click="showFilters" data-testid="resourceBookingFilterBtn">
							<span class="ico-filters icon-adjust-horiz icon-adjust-vert"></span><span class="btn-icon-text">Filters</span>
						</button>
						<span class="separator"></span>
						<div class="chiclets-inline-scroller">
							<div class="chiclets-inline-container" tabindex="0">
								<button class="chiclet disabled" data-testid="chicletBtn" disabled v-for="chic in searchChiclets" :key="chic.value">
									<span class="sr-only">Showing “</span><span :id="`chicletName_${chic.name}`">{{ chic.name }}</span><span class="sr-only">” Filter</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="filters-modal modal fade" role="dialog" aria-labelledby="resourceBookingFiltersModalTitle" aria-hidden="true" tabindex="-1" ref="resourceBookingFiltersModal" id="resourceBookingFiltersModal" data-testid="resourceBookingFiltersModal">
			<div class="modal-dialog" role="document">
				<div class="modal-content">

					<div class="modal-header pos-sticky">
						<button type="button" class="filters-modal-close btn btn-link btn-link-simple" aria-label="Close" data-dismiss="modal">Close</button>
						<h1 class="modal-title h6" id="resourceBookingFiltersModalTitle">Filters</h1>
					</div>

					<div class="modal-body">
						<div class="m-b-grid" id="resourceFilters">
							<ResourceBookingFiltersSingleSelect
								v-for="(facet, index) in facets"
								:id="facet.filter"
								:ref="facet.filter"
								:data-testid="facet.filter"
								:key="index"
								:facetLabel="facet.label"
								:facetName="facet.filter"
								:choices="facet.values"
								:selectedFilter="facet.selectedFilter"
								:isWaiting="isWaiting"
								@change="updateSelectedFilters">
							</ResourceBookingFiltersSingleSelect>
						</div>
					</div>

					<div class="modal-footer">
						<button type="button" class="filters-modal-apply btn btn-primary" @click="applyFilters()" :disabled="isWaiting" data-testid="resourceBookingModalApplyFiltersBtn" autofocus>Apply Filters</button>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import _ from 'lodash';
import ResourceBookingFiltersSingleSelect from './ResourceBookingFiltersSingleSelect.vue';

export default defineComponent({
	name: 'ResourceBookingFilters',
	components: {
		ResourceBookingFiltersSingleSelect
	},
	props: {
		facets: {
			type: Array,
			default: () => []
		},
		isWaiting: {
			type: Boolean,
			default: false
		},
		isInitialLoad: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			searchChiclets: [],
			initialFacets: [],
			filtersApplied: false
		};
	},
	watch: {
		isInitialLoad(isInitialLoad) {
			if (isInitialLoad) {
				this.showFilters();
			}
		}
	},
	mounted() {
		$(this.$refs.resourceBookingFiltersModal).on('hidden.bs.modal', this.closeFilters);
	},
	methods: {
		ref(filterId) {
			let _ref = this.$refs[filterId];
			if (_ref && _ref.length) _ref = _ref[0];
			return _ref;
		},
		updateSelectedFilters(editedfacet, filterClicked, shouldApplyUpdates) {
			// Refresh Data after filters change
			this.$emit('changed', editedfacet, filterClicked, shouldApplyUpdates);
		},
		getQueryStringValues() {
			const querystringValues = [];
			for (let facet of this.facets) {
				const selectedFilterValue = this.ref(facet.filter).selectedFilter;
				if (selectedFilterValue) {
					querystringValues.push({
						filter: facet.filter,
						value: selectedFilterValue.key
					});
				}
			}

			return querystringValues;
		},
		triggerSelectedDateChange(dateFilterKey, applyFilters) {
			this.ref('date').handleStateChanged(dateFilterKey, applyFilters); // Apply filters immediately if changing from date nav
		},
		showFilters() {
			this.filtersApplied = false;
			this.initialFacets = _.cloneDeep(this.facets);
			$(this.$refs.resourceBookingFiltersModal).modal('show');
		},
		hideFilters() {
			$(this.$refs.resourceBookingFiltersModal).modal('hide');
		},
		applyFilters() {
			this.filtersApplied = true;
			this.$emit('applyFilters', this.facets);
			this.hideFilters();
			this.applyChiclets(this.facets);
		},
		applyChiclets(facets) {
			this.searchChiclets = [];
			for (let facet of facets) {
				const selectedFilterValue = this.ref(facet.filter).selectedFilter;
				if (!selectedFilterValue) continue;
				
				if (facet.filter === 'date') continue;
				if (selectedFilterValue && selectedFilterValue.value.toLowerCase() === 'any time') continue;

				const cleanChicletName = selectedFilterValue.value.split('|')[0];
				this.searchChiclets.push({
					name: cleanChicletName,
					value: selectedFilterValue.key
				});
			}
		},
		closeFilters() {
			if (!this.filtersApplied) {
				this.$emit('closeFilters', this.initialFacets);
			}

			this.filtersApplied = false;
		}
	}
});
</script>

<style lang="scss" scoped>
@import "../styles/resourceBookingFilters.scss";
</style>
